import 'regenerator-runtime/runtime';
import React from 'react';
import { hydrate } from 'react-dom';
import datalayer from '@mfe/data-layer';
import loadPolyfills from '@mfe/browse-polyfill-loader';
import getClientErrorLogger from './helpers/client-helpers/get-client-error-logger';
import AppElement from './app';

const errorLogger = getClientErrorLogger();

const render = (App: JSX.Element) => {
  const customLandingPageDiv = document.getElementById('custom-landing-page');

  if (customLandingPageDiv) {
    hydrate(App, customLandingPageDiv);
  } else {
    errorLogger(
      new Error(
        'Error mounting Custom Landing Page. Unable to find root element with id: custom-landing-page.'
      )
    );
  }
};

loadPolyfills(window.__CUSTOM_LANDING_PAGE_POLYFILL__.promisePolyfillPath)(
  () => {
    render(
      <AppElement
        {...window.__CUSTOM_LANDING_PAGE_STATE__}
        datalayer={window.gap.datalayer || datalayer}
        errorLogger={errorLogger}
      />
    );
  }
);
